/* eslint-disable @typescript-eslint/no-empty-interface */
import pick from 'lodash/pick';
import React from 'react';
import { GraphMode } from '../../constants';
import { EditorContextProps, withEditorContext } from '../../hooks';
import { Group, Shape } from '../../types';
import { getGlobal, updateGlobal } from '../../utils';
import FlowChartDndTile from '../FlowChartDndTile';

interface FlowChartDndContainerProps extends EditorContextProps {
  style?: React.CSSProperties;
  className?: string;
  children: React.ReactNode;
}

class FlowChartDndContainerCmp extends React.Component<FlowChartDndContainerProps> {
  static FlowChartDndTile = FlowChartDndTile;

  componentDidMount() {
    document.addEventListener('mouseup', this.handleMouseUp, false);
  }

  componentWillUnmount() {
    document.removeEventListener('mouseup', this.handleMouseUp, false);
  }

  handleMouseUp = () => {
    const { graph } = this.props;

    if (!graph) return;
    if (graph?.getCurrentMode() !== GraphMode.AddNode) return;

    const group: Group = graph.get('group');
    const shape: Shape = group.findByClassName(
      getGlobal(graph).component.itemPanel.delegateShapeClassName,
    ) as Shape;

    if (shape) {
      shape.remove(true);
      graph.paint();
    }

    updateGlobal(graph, { component: { itemPanel: { model: null } } });

    graph.setMode(GraphMode.Default);
  };

  render() {
    const { children } = this.props;

    return <div {...pick(this.props, ['style', 'className', 'data-test'])}>{children}</div>;
  }
}

export const FlowChartDndContainer =
  withEditorContext<FlowChartDndContainerProps>(FlowChartDndContainerCmp);

export default FlowChartDndContainer;
